import { createReducer, createAction } from '@reduxjs/toolkit';
import type { ColorsState } from './types';

const initState: ColorsState = {
  scheme: 'light',
};

export const changeScheme = createAction<string>('colors/changeScheme');
export const clear = createAction('clear');

export default createReducer<ColorsState>(initState, {
  [changeScheme.type]: (state, action) => ({
    ...state,
    scheme: action.payload,
  }),
  [clear.type]: () => {
    return initState;
  },
});
